import { graphql } from 'ms-client/graphql/user-pool'

import {
  DeleteOembedMapMutation,
  DeleteOembedMapMutationVariables
} from '~map-preview/types/__generated/gql/graphql'

const deleteEmbedMapMutation = /* GraphQL */ `
  mutation DeleteOembedMap($mapId: ID!) {
    deleteOembedMap(mapId: $mapId)
  }
`

export const deleteEmbedMap = async (
  variables: DeleteOembedMapMutationVariables
) => {
  const data = await graphql<
    DeleteOembedMapMutation,
    DeleteOembedMapMutationVariables
  >({
    query: deleteEmbedMapMutation,
    variables
  })
  return data?.deleteOembedMap
}
